/***
 *
 *   PROJECT IDENTITY MARK
 *   A project's logo as its own wordmark, with an initial-letter fallback.
 *
 *   Distinct from ProjectMark next door: that one is a square avatar for lists
 *   and switchers, this one is the lockup a white-labelled page wears in place
 *   of the Valetify logo — so it keeps the image's aspect ratio and aligns left.
 *
 *   Lifted out of views/website/account/project.js, which had it inline, now
 *   that the public header and the project sign-in panel need it too.
 *
 *   PROPS
 *   name: display name, used for the initial fallback
 *   filePath: raw `file_path` off the API (optional)
 *   alt: image alt text
 *   size: 'sm' for the public header lockup, 'lg' for the intake card and the
 *         sign-in panel (default 'lg')
 *   className / fallbackClassName: injected classes
 *
 **********/

import { logoUrl } from 'components/lib';

const Sizes = {
    sm: { image: 'h-8 w-auto max-w-[9rem]', fallback: 'h-8 w-8 rounded-md text-sm' },
    lg: { image: 'h-14 w-auto max-w-[10rem]', fallback: 'h-14 w-14 rounded-lg text-lg' },
};

export function ProjectIdentityMark(props) {
    const src = logoUrl(props.filePath);
    const size = Sizes[props.size] || Sizes.lg;
    const initial = (props.name || '?').slice(0, 1).toUpperCase();

    if (src) {
        return (
            <img
                src={src}
                alt={props.alt || props.name || ''}
                className={`${size.image} shrink-0 object-contain object-left ${props.className || ''}`}
            />
        );
    }

    return (
        <div
            className={`flex ${size.fallback} shrink-0 items-center justify-center bg-muted font-semibold text-text-muted ${props.fallbackClassName || ''}`}
            aria-hidden>
            {initial}
        </div>
    );
}
